module.exports = __webpack_public_path__ + "img/product6.c510468f.png";